import Api from '../../api'
import axios from '@/js/api'
// import Vue from 'vue'
// import {Message} from 'element-ui'

import date from '../../js/date.js'
import breadcrumb from './breadcrumb.js'
const state = {
	trigger: {
		numberPie: false,
		hospital: false,
		tradarFlag:false
	},
	destroy: {
		flag: true
	},
	reportCountList:{
		TotalHospitalCount:0, //纳入质控影像中心
		TotalReportCount:0, //被质控报告总数
		TotalFirstAproverCount:0, //被质控医生人数
		TotalTechnicianCount:0, //被质控技师人数
		QCedCount:0 //总质控数
	},
	getCountParameter:{
		regionId:'',
		hospitalGuid:'',
		doctorName:'',
		type:'2',
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99]
	},
	getAvgScoreParameter:{
		regionId:'',
		hospitalGuid:'',
		doctorName:'',
		type:'2',
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99],
		sortType:2,
		pageIndex:1,
		pageCount:10
	},
	getHospitalAVGScoreParameter:{
		regionId:'',
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99],
		sortType:2
	},
	getQCedReportMonthlyParameter:{
		regionId:'',
		modalityType:'',
		bodyPart:'',
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99]
	},
	getUnqualifiedMonthlyParameter:{
		regionId:'',
		doctorName:'',
		modalityType:'',
		bodyPart:'',
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99]
	},
	getDoctorURMonthlyParameter:{
		regionId:'',
		modalityType:'',
		bodyPart:'',
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99]
	},
	getRegionAVGScoreParameter:{
		type:2,
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99],
		sortType:2
	},
	setDateArr: {
		data: [date.sliderMarks[0],date.sliderMarks[99]]
	},
	setDate:{
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99]
	},
	summary:{},
	visPieColorList:breadcrumb.state.visPieColorList,
	doctorsAvgScore:[],
	technicianAvgScore:[],
	doctorsHospital:[],
	qcedReportMonthlyList:[],
	unqualifiedMonthlyList:[],
	doctorURMonthlyList:[],
	regionAVGScoreList:[],
	setDateCount:{
		startdt:date.sliderMarks[0],
		enddt:date.sliderMarks[99]
	},
	HospitalCountList:{
		hospitalGuid:'',
		startdt:date.start,
		enddt:date.end
	},
	DoctorCountList:{
		hospitalGuid:'',
		type:2,
		doctorName:'',
		startdt:date.start,
		enddt:date.end
	},
	doctorCountLists:{
		MoreThanRate:0
	},
	hospitalCountLists:{
		MoreThanRate:0
	},
	//影像中心日期
	reportDate: {
		data: [date.sliderMarks[0],date.sliderMarks[99]]
	},
	radarDoctorRadar:{
		hospitalGuid:'',
		type:2, //2是报告 3是影像
		doctorName:'',
		startdt:date.start,
		enddt:date.end
	},
	radarDoctorRadarList:[],
	radarHospital:{
		hospitalGuid:'',
		type:2, //2是报告 3是影像
		startdt:date.start,
		enddt:date.end,
		regionId:''
	},
	radarHospitalList:[],
	scoreMonthlyParameter:{
		regionId:'',
		hospitalGuid:'',
		type:2, //2是报告 3是影像
		modalityType:'',
		scanType:'',
		bodyPart:'',
		startdt:date.start,
		enddt:date.end
	},
	doctorScoreMonthlyParameter:{
		regionId:'',
		hospitalGuid:'',
		type:2, //2是报告 3是影像
		modalityType:'',
		scanType:'',
		bodyPart:'',
		startdt:date.start,
		enddt:date.end
	},
	scoreMonthlyList:[],
	doctorScoreMonthly:[],
	doctorsAvgScoreArr:{
		regionId: '',
		hospitalGuid: '',
		type: 2,
		sortType: 2,
		pageIndex: 1,
		pageCount: 5,
		startdt:date.start,
		enddt:date.end
	},
	reportListParameter:{
		hospitalGuid: '',
		regionId: '',
		type:'',
		doctorGuid: '', //医生编号
		doctorName: '', //医生名字
		isUnqualified:false,
		isSerious: false,
		startdt:date.start,
		enddt:date.end,
		pageIndex: 1,
		pageCount: 10,
		modalityType: '',
		scanType: '',
		bodypart: ''
	},
	reportList:{},
	doctorUnqualified:[],
	//面包屑内容设置
	visbreadcrumbList: [],
	portiaitbreadcrumbList: [],
	doctorbreadcrumbList: [],
	regionbreadcrumbList: [],
	doctorQCTaskParameter:{
		hospitalGuid:'',
		type:'',
		name:'',
		startdt:date.start,
		enddt:date.end,
		pageIndex: 1,
		pageCount: 10
	},
	qCTaskList:[],
	HospitalAVGScoreArr:{
		regionId:'',
		type:2,
		startdt:date.start,
		enddt:date.end,
		sortType:2
	},
	HospitalAVGScoreList:[],
	
};
const getters = {

};
const mutations = {
	setvisBreadcrumbList(state, arr) {
		state.visbreadcrumbList = [];
	},
	setportiaitbreadcrumbList(state, arr) {
		state.portiaitbreadcrumbList = [];
	},
	setregionbreadcrumbList(state, arr) {
		state.regionbreadcrumbList = [];
	},
	setdoctorbreadcrumbList(state, arr) {
		state.doctorbreadcrumbList = [];
	},
	setDate(state, arr){
		state.setDate.startdt = arr[0];
		state.setDate.enddt = arr[1];
	},
	//质控个数总数
	SetSummaryCount(state, arr) {
		state.reportCountList.TotalHospitalCount = arr.TotalHospitalCount;
		state.reportCountList.TotalReportCount = arr.TotalReportCount;
		state.reportCountList.TotalFirstAproverCount = arr.TotalFirstAproverCount;
		state.reportCountList.TotalTechnicianCount = arr.TotalTechnicianCount;
		state.reportCountList.QCedCount = arr.QCedCount;
	},
	// 监察员树层级
	// SetRegions(state, arr){
	// 	state.getCountParameter.regionId = arr.data.Regions[0].UniqueId;
	// },
	SetSummaryPie(state, arr){
		state.summary = arr.data;
		if (state.summary.ModalityTypes) {
			state.summary.ModalityTypes.map((res, index) => {
				res.color = state.visPieColorList.color1[index]
			})
		}
		if (state.summary.ScanTypes) {
			state.summary.ScanTypes.map((res, index) => {
				res.color = state.visPieColorList.color2[index]
			})
		}
		if (state.summary.BodyParts) {
			state.summary.BodyParts.map((res, index) => {
				res.color = state.visPieColorList.color3[index]
			})
		}
		state.trigger.numberPie = true;
	},
	SetDoctorsAvgScore(state, arr){
		if (state.getAvgScoreParameter.type == 2||state.getAvgScoreParameter.type == 4) {
			state.doctorsAvgScore = arr.data;
		}else{
			state.technicianAvgScore = arr.data;
		}
	},
	SetDoctorsTop5AvgScore(state, arr){
		state.doctorsAvgScore.Doctors = arr.data.Doctors;
		state.technicianAvgScore.Doctors = arr.data.Technichian;
	},
	setHospitalAVGScore(state, arr){
		state.trigger.hospital = true;
		state.doctorsHospital = arr.data.Hospitals;
	},
	setQCedReportMonthly(state, arr){
		state.trigger.hospital = true;
		state.qcedReportMonthlyList = arr.data.Months;
	},
	setUnqualifiedMonthly(state, arr){
		state.trigger.hospital = true;
		state.unqualifiedMonthlyList = arr.data.Months;
	},
	setDoctorURMonthly(state, arr){
		state.trigger.hospital = true;
		state.doctorURMonthlyList = arr.data.Months;
	},
	setRegionAVGScore(state, arr){
		state.trigger.hospital = true;
		state.regionAVGScoreList = arr.data.Regions;
	},
	setHospitalCountList(state, arr){
		state.hospitalCountLists = arr.data;
		let percentage = state.hospitalCountLists.MoreThanRate;
		let percentage1 = state.hospitalCountLists.ImageMoreThanRate;
		state.hospitalCountLists.MoreThanRate = Number(percentage.substring(0, percentage.lastIndexOf('%')));
		state.hospitalCountLists.ImageMoreThanRate = Number(percentage1.substring(0, percentage1.lastIndexOf('%')));
	},
	setDoctorCountList(state, arr){
		state.doctorCountLists = arr.data;
		let percentage = state.doctorCountLists.MoreThanRate == null?'0%':state.doctorCountLists.MoreThanRate;
		state.doctorCountLists.MoreThanRate = Number(percentage.substring(0, percentage.lastIndexOf('%')));
	},
	setradarHospitalList(state, arr){
		state.radarHospitalList = arr.data;
		state.trigger.tradarFlag = true;
	},
	setDoctorRadarList(state, arr){
		state.radarDoctorRadarList = arr.data;
		state.trigger.tradarFlag = true;
	},
	setscoreMonthlyList(state, arr){
		state.trigger.hospital = true;
		state.scoreMonthlyList = arr.data.Months;
	},
	setdoctorScoreMonthly(state, arr){
		state.trigger.hospital = true;
		state.doctorScoreMonthly = arr.data.Months;
	},
	setreportDate(state, arr){
		state.reportDate.data = arr;
	},
	setDoctorUnqualified(state, arr){
		state.doctorUnqualified = arr.data;
	},
	setReportList(state, arr){
		state.reportList = arr.data;
	},
	setQCTask(state, arr){
		state.qCTaskList = arr.data;
	},
	setHospitalAVGScoreList(state, arr){
		state.trigger.hospital = true;
		state.HospitalAVGScoreList = arr.data.Hospitals;
	}
};
const actions = {
	// // 监察员树层级
	// GetRegions({
	// 	state,
	// 	commit
	// },arr) {
	// 	return axios.ajaxGet('get', Api.api.supervisor.GetRegions).then(res => {
	// 		commit('SetRegions', res);
	// 	}).finally(() => {});
	// },
	// 质控个数
	GetCount({
		state,
		commit
	},arr) {
		state.getCountParameter.startdt = arr.startdt;
		state.getCountParameter.enddt = arr.enddt;
		return axios.ajaxGet('get', Api.api.supervisor.GetCount, state.getCountParameter).then(res => {
			commit('SetSummaryCount',res.data)
		}).finally(() => {});
	},
	// 获取统计概要(饼图)
	GetSummary({
		state,
		commit
	},arr) {
		state.getCountParameter.startdt = arr.startdt;
		state.getCountParameter.enddt = arr.enddt;
		state.getCountParameter.hospitalGuid = arr.hospitalGuid;
		return axios.ajaxGet('get', Api.api.supervisor.GetSummary, state.getCountParameter).then(res => {
			commit('SetSummaryPie', res);
		}).finally(() => {});
	},
	// 全国医生/技师排名
	GetDoctorsAvgScore({
		state,
		commit
	}) {
		return axios.ajaxGet('get', Api.api.supervisor.GetDoctorsAvgScore, state.getAvgScoreParameter).then(res => {
			commit('SetDoctorsAvgScore', res);
		}).finally(() => {});
	},
	//管辖下区域/医院所有医生/技师平均分排名
	GetDoctorsTop5AvgScore({
		state,
		commit
	}) {
		return axios.ajaxGet('get', Api.api.supervisor.GetDoctorsTop5AvgScore, state.getAvgScoreParameter).then(res => {
			commit('SetDoctorsTop5AvgScore', res);
		}).finally(() => {});
	},
	// 影像中心排名
	GetHospAvgScore({
		state,
		commit
	},arr) {
		state.getHospitalAVGScoreParameter.regionId =state.getCountParameter.regionId;
		state.getHospitalAVGScoreParameter.startdt = arr.startdt;
		state.getHospitalAVGScoreParameter.enddt = arr.enddt;
		return axios.ajaxGet('get', Api.api.supervisor.GetHospAvgScore, state.getHospitalAVGScoreParameter).then(res => {
			commit('setHospitalAVGScore', res);
		}).finally(() => {});
	},
	//报告数量
	GetQCedReportMonthly({
		state,
		commit
	},arr) {
		state.getQCedReportMonthlyParameter = {
			regionId:state.getCountParameter.regionId,
			modalityType:arr.modalityType,
			bodyPart:arr.bodyPart,
			scanType:arr.scanType,
			startdt:arr.startdt,
			enddt:arr.enddt
		}
		return axios.ajaxGet('get', Api.api.supervisor.GetQCedReportMonthly, state.getQCedReportMonthlyParameter).then(res => {
			commit('setQCedReportMonthly', res);
		}).finally(() => {});
	},
	//医院不合格报告
	GetUnqualifiedReportMonthly({
		state,
		commit
	},arr) {
		state.getUnqualifiedMonthlyParameter={
			regionId:state.getCountParameter.regionId,
			hospitalGuid:arr.hospitalGuid,
			modalityType:arr.modalityType,
			bodyPart:arr.bodyPart,
			scanType:arr.scanType,
			startdt:arr.startdt,
			enddt:arr.enddt
		}
		return axios.ajaxGet('get', Api.api.supervisor.GetUnqualifiedReportMonthly, state.getUnqualifiedMonthlyParameter).then(res => {
			commit('setUnqualifiedMonthly', res);
		}).finally(() => {});
	},
	//医生不合格报告
	GetDoctorURMonthly({
		state,
		commit
	},arr) {
		state.getDoctorURMonthlyParameter={
			regionId:state.getCountParameter.regionId,
			hospitalGuid:arr.hospitalGuid,
			doctorName:arr.doctorName,
			type:arr.type,
			modalityType:arr.modalityType,
			bodyPart:arr.bodyPart,
			scanType:arr.scanType,
			startdt:arr.startdt,
			enddt:arr.enddt
		}
		return axios.ajaxGet('get', Api.api.supervisor.GetDoctorURMonthly, state.getDoctorURMonthlyParameter).then(res => {
			commit('setDoctorURMonthly', res);
		}).finally(() => {});
	},
	GetRegionAVGScore({
		state,
		commit
	},arr) {
		state.getRegionAVGScoreParameter.startdt = arr.startdt;
		state.getRegionAVGScoreParameter.enddt = arr.enddt;
		return axios.ajaxGet('get', Api.api.supervisor.GetRegionAVGScore, state.getRegionAVGScoreParameter).then(res => {
			commit('setRegionAVGScore', res);
		}).finally(() => {});
	},
	//影像中心顶部总数
	GetHospitalCount({
		state,
		commit
	},arr) {
		state.HospitalCountList.startdt = arr.startdt;
		state.HospitalCountList.enddt = arr.enddt;
		state.HospitalCountList.hospitalGuid = arr.hospitalGuid;
		state.HospitalCountList.regionId = arr.regionId;
		return axios.ajaxGet('get', Api.api.supervisor.GetHospitalCount, state.HospitalCountList).then(res => {
			commit('setHospitalCountList', res);
		}).finally(() => {});
	},
	//医生顶部总数
	GetDoctorCount({
		state,
		commit
	},arr) {
		state.DoctorCountList.startdt = arr.startdt;
		state.DoctorCountList.enddt = arr.enddt;
		state.DoctorCountList.type = arr.type;
		state.DoctorCountList.hospitalGuid = arr.hospitalGuid;
		state.DoctorCountList.doctorName = arr.doctorName;
		return axios.ajaxGet('get', Api.api.supervisor.GetDoctorCount, state.DoctorCountList).then(res => {
			commit('setDoctorCountList', res);
		}).finally(() => {});
	},
	//医院雷达图
	GetHospitalRadar({
		state,
		commit
	},arr) {
		state.radarHospital.startdt = arr.startdt;
		state.radarHospital.enddt = arr.enddt;
		state.radarHospital.hospitalGuid = arr.hospitalGuid;
		state.radarHospital.type = arr.type;
		state.radarHospital.regionId = arr.regionId;
		return axios.ajaxGet('get', Api.api.supervisor.GetHospitalRadar, state.radarHospital).then(res => {
			commit('setradarHospitalList', res);
		}).finally(() => {});
	},
	//医生雷达图
	GetDoctorRadar({
		state,
		commit
	},arr) {
		state.radarDoctorRadar.startdt = arr.startdt;
		state.radarDoctorRadar.enddt = arr.enddt;
		state.radarDoctorRadar.hospitalGuid = arr.hospitalGuid;
		state.radarDoctorRadar.type = arr.type;
		state.radarDoctorRadar.doctorName = arr.doctorName;
		return axios.ajaxGet('get', Api.api.supervisor.GetDoctorRadar, state.radarDoctorRadar).then(res => {
			commit('setDoctorRadarList', res);
		}).finally(() => {});
	},
	//医院报告份数每月
	GetScoreMonthly({
		state,
		commit
	},arr) {
		state.scoreMonthlyParameter.startdt = arr.startdt;
		state.scoreMonthlyParameter.enddt = arr.enddt;
		state.scoreMonthlyParameter.hospitalGuid = arr.hospitalGuid;
		state.scoreMonthlyParameter.type = arr.type;
		state.scoreMonthlyParameter.modalityType = arr.modalityType;
		state.scoreMonthlyParameter.bodyPart = arr.bodyPart;
		state.scoreMonthlyParameter.scanType = arr.scanType;
		state.scoreMonthlyParameter.regionId = arr.regionId;
		return axios.ajaxGet('get', Api.api.supervisor.GetScoreMonthly, state.scoreMonthlyParameter).then(res => {
			commit('setscoreMonthlyList', res);
		}).finally(() => {});
	},
	//医生报告份数每月
	GetDoctorScoreMonthly({
		state,
		commit
	},arr) {
		state.doctorScoreMonthlyParameter.startdt = arr.startdt;
		state.doctorScoreMonthlyParameter.enddt = arr.enddt;
		state.doctorScoreMonthlyParameter.hospitalGuid = arr.hospitalGuid;
		state.doctorScoreMonthlyParameter.doctorName = arr.doctorName;
		state.doctorScoreMonthlyParameter.type = arr.type;
		state.doctorScoreMonthlyParameter.modalityType = arr.modalityType;
		state.doctorScoreMonthlyParameter.bodyPart = arr.bodyPart;
		state.doctorScoreMonthlyParameter.scanType = arr.scanType;
		return axios.ajaxGet('get', Api.api.supervisor.GetDoctorScoreMonthly, state.doctorScoreMonthlyParameter).then(res => {
			commit('setdoctorScoreMonthly', res);
		}).finally(() => {});
	},
	//不合格医生排行
	GetDoctorUnqualifiedReport({
		state,
		commit
	}) {
		return axios.ajaxGet('get', Api.api.supervisor.GetDoctorUnqualifiedReport, state.doctorsAvgScoreArr).then(res => {
			commit('setDoctorUnqualified', res)
		}).finally(() => {});
	},
	//监察员报告列表
	GetReportList({
		state,
		commit
	}, arr) {
		return axios.ajaxPost('post', Api.api.supervisor.GetReportList, state.reportListParameter).then(res => {
			commit('setReportList', res)
		}).finally(() => {});
	},
	//被质控各批次-影像中心
	GetHospitalQCTask({
		state,
		commit
	}, arr) {
		return axios.ajaxGet('get', Api.api.supervisor.GetHospitalQCTask, state.doctorQCTaskParameter).then(res => {
			commit('setQCTask', res)
		}).finally(() => {});
	},
	//被质控各批次个人
	GetDoctorQCTask({
		state,
		commit
	}, arr) {
		return axios.ajaxGet('get', Api.api.supervisor.GetDoctorQCTask, state.doctorQCTaskParameter).then(res => {
			commit('setQCTask', res)
		}).finally(() => {});
	},
	//影像机构平均分排名
	GetHospitalAVGScore({
		state,
		commit
	}, arr) {
		state.HospitalAVGScoreArr.startdt = arr.startdt;
		state.HospitalAVGScoreArr.enddt = arr.enddt;
		state.HospitalAVGScoreArr.type = arr.type;
		state.HospitalAVGScoreArr.regionId = arr.regionId;
		return axios.ajaxGet('get', Api.api.supervisor.GetHospitalAVGScore, state.HospitalAVGScoreArr).then(res => {
			commit('setHospitalAVGScoreList', res);
		}).finally(() => {});
	},
}
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
